import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  formRow: {
    marginBottom: 10,
    width: '100%'
  },
  formControl: {
    width: '100%',
    paddingTop: 5,
    margin: '8px 0',
    '& .MuiInputLabel-root': {
      width: 'max-content'
    }
  }
})
